import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { AccountSetupProgress } from "@models/account-setup-progress";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const accountSetupApi = createApi({
  reducerPath: "accountSetupApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/setup`,
    prepareHeaders: prepareAuthHeaders,
  }),
  tagTypes: ["AccountSetupProgress"],
  endpoints: (builder) => ({
    getAccountSetupProgress: builder.query<AccountSetupProgress, string>({
      providesTags: ["AccountSetupProgress"],
      query: (patientId: string) => {
        return {
          url: "progress",
          method: "GET",
          params: { patientId },
        };
      },
    }),
  }),
});

export const { useGetAccountSetupProgressQuery } = accountSetupApi;
